import { render, staticRenderFns } from "./PrecificationBaseForm.vue?vue&type=template&id=778f08db&scoped=true&"
import script from "./PrecificationBaseForm.vue?vue&type=script&lang=js&"
export * from "./PrecificationBaseForm.vue?vue&type=script&lang=js&"
import style0 from "./PrecificationBaseForm.vue?vue&type=style&index=0&id=778f08db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f08db",
  null
  
)

export default component.exports